/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux'; // FUCK REDUX!!!
import { useHistory } from 'react-router';
import { Formik, Form, Field } from 'formik';
import { Heading, Stack, Box, Button, Input } from 'chaser-components';
import ChaserLogo from '../../../../assets/login.svg';
import EmailIcon from '../../../../assets/email.svg';
import LockIcon from '../../../../assets/lock.svg';
import CloseIcon from '../../../../assets/close.svg';
import style from './LoginForm.module.scss';
import { useHistoryState } from '../../../../hooks/useGlobalState';
import { logError } from '../../../../analytics';
import { setUserData } from '../../duck/actions/login';
import { LOGIN } from '../../duck/types';
import config from '../../../../config/index';
import axios from 'axios';

function PasswordForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useHistoryState();
  const { loginError, from = { pathname: '/' } } = state;

  function clearError() {
    setState({ loginError: null });
  }

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
      }}
      onSubmit={async (values, actions) => {
        const { email, password } = values;

        try {
          const { data } = await axios.post(`${config.host}/login`, {
            email,
            password,
          });

          dispatch(setUserData(data));
          dispatch({ type: LOGIN });
          history.push(from.pathname);
        } catch (error) {
          logError(error, { error: loginError });

          const errorMessage =
            error.response && error.response.status === 429
              ? error.response.data.error
              : 'Please enter a correct email and password.';

          setState({ loginError: errorMessage });
        }

        actions.setSubmitting(false);
      }}>
      {({ isSubmitting }) => (
        <Form>
          <div className={style.loginFormHead}>
            <img src={ChaserLogo} alt="" />
          </div>
          <Box p="large">
            <Stack gap="large" textAlign="center">
              <Heading as="h2">Sign in to Partner Hub</Heading>
              <Stack alignItems="center">
                {loginError && (
                  <div className={style.loginErrorMessage}>
                    <p
                      className={style.loginErrorText}
                      data-testid="login-form-error-msg">
                      {loginError}
                    </p>
                    <button
                      type="button"
                      className={style.loginErrorIcon}
                      onClick={() => {
                        clearError();
                      }}>
                      <img alt="" src={CloseIcon} />
                    </button>
                  </div>
                )}
                <Field
                  as={Input}
                  icon={<img src={EmailIcon} alt="" />}
                  name="email"
                  placeholder="Enter your email address"
                  width="100%"
                />
                <Field
                  as={Input}
                  icon={<img src={LockIcon} alt="" />}
                  name="password"
                  type="password"
                  placeholder="Enter password"
                  width="100%"
                />
                <Button
                  data-testid="submit-button"
                  type="submit"
                  style={{ width: '100%' }}
                  loading={isSubmitting}>
                  Login
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

function LoginForm() {
  const [view, setView] = useState('password');

  const views = {
    password: <PasswordForm setView={setView} />,
  };

  return views[view];
}

export default LoginForm;
